import React from 'react';
import { BONUS_TOTAL, bonuses } from '../data/unstuckContent';
export function BonusesSection() {
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby="bonuses-title" data-id="element-18" data-mp="gweydbt9t8rk">
      <div className="mx-auto max-w-6xl px-5" data-id="element-19" data-mp="vt621x9z96mz">
        <p className="text-center text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-20" data-mp="vqtd305sxw0f">
          Always included
        </p>
        <h2 id="bonuses-title" className="mt-3 text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-21" data-mp="14ssuhtkqb23w">
          5 Strategic bonuses
        </h2>

        <ul className="mt-8 grid gap-x-4 gap-y-8 sm:grid-cols-3 lg:grid-cols-5" data-id="element-22" data-mp="1eiuk4psqcskx">
          {bonuses.map(b => <li key={b.number} className="flex flex-col text-center" data-id="element-23" data-mp="19l2p3mwsgqci">
              <img src={b.image} alt={`${b.title} — official UNSTUCK bonus cover`} className="mx-auto w-full max-w-[11rem]" width={1024} height={1536} data-id="element-24" data-mp="1nkvfti8bf6kh" />
              <p className="mt-3 text-[10px] font-semibold uppercase tracking-[0.22em] text-champagne" data-id="element-25" data-mp="3psoe7xpkrnie">
                Bonus {b.number}
              </p>
              <h3 className="mt-1 font-display text-base font-semibold uppercase leading-tight text-ivory-50" data-id="element-26" data-mp="2kukom7wdz90">
                {b.title}
              </h3>
              <p className="mx-auto mt-1.5 max-w-[15rem] text-[13px] leading-snug text-body" data-id="element-27" data-mp="ck1vb1n8zfsf">
                {b.line}
              </p>
              <p className="mt-auto pt-2 text-[10px] font-semibold uppercase tracking-[0.16em]" data-id="element-28" data-mp="gk2ltknmfhfu">
                <span className="text-muted line-through" data-id="element-29" data-mp="ld595b1t1unl">{b.value} USD</span>
                <span className="ml-2 text-champagne" data-id="element-30" data-mp="qbqa5covsid3">Free</span>
              </p>
            </li>)}
        </ul>

        <p className="mt-10 border-y border-champagne/25 py-5 text-center text-[13px] font-semibold uppercase tracking-[0.18em] text-ivory-100" data-id="element-31" data-mp="vbkx555jcnsv">
          Total bonus value <span className="text-muted line-through" data-id="element-32" data-mp="akz600dt70kr">{BONUS_TOTAL}</span>
          <span className="ml-3 text-champagne" data-id="element-33" data-mp="aiw7st2i614y">→ Free with your UNSTUCK</span>
        </p>
      </div>
    </section>;
}